import React from 'react';

export interface IconProps {
	color: string;
}

const CircleSvg = (props: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="11"
			height="11"
			viewBox="0 0 11 11"
			fill="none"
		>
			<circle
				cx="5.5"
				cy="5.5"
				r="5"
				fill={props.color}
			/>
		</svg>
	);
};

export default CircleSvg;